import { useEffect } from 'react';
import {
    BodyMediumEmphasized,
    BodySmallEmphasized,
    Icon,
    isNonMobileWeb,
    SplitIcon,
    View,
    XStack,
} from 'smoothie';

interface IncomeSplitButtonProps {
    onClose: () => void;
    onSubmitIncomeSplit: () => void;
    incomeSplitIsActive: boolean;
}

export const IncomeSplitButton = ({
    onClose,
    onSubmitIncomeSplit,
    incomeSplitIsActive,
}: IncomeSplitButtonProps) => {
    useEffect(() => {
        if (isNonMobileWeb && !document.getElementById('hover-shadow')) {
            const style = document.createElement('style');
            style.id = 'hover-shadow';
            style.textContent = `.hover-shadow:hover {
        box-shadow: 0 0 0 4px rgba(17,17,17,0.07);
        transition: box-shadow 150ms ease;
      }`;
            document.head.appendChild(style);
        }
    }, [isNonMobileWeb]);

    return (
        <View
            onPress={() => {
                onClose();
                onSubmitIncomeSplit();
            }}
            height={56}
            backgroundColor="$gray200"
            borderRadius={16}
            paddingVertical={16}
            paddingHorizontal={16}
            cursor="pointer"
            className={isNonMobileWeb ? 'hover-shadow' : undefined}
        >
            <XStack gap={8} alignItems="center" justifyContent="center">
                <View rotate="180deg">
                    <Icon icon={SplitIcon} size={18} color="$gray1200" />
                </View>
                <BodyMediumEmphasized>Income Split</BodyMediumEmphasized>
                {incomeSplitIsActive && (
                    <View
                        backgroundColor="$green800"
                        borderRadius={16}
                        paddingHorizontal={12}
                        paddingBottom={4}
                        paddingTop={isNonMobileWeb ? 4 : 2}
                    >
                        <BodySmallEmphasized color="$white">
                            ON
                        </BodySmallEmphasized>
                    </View>
                )}
            </XStack>
        </View>
    );
};
